import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ClientProfileService, TenantService} from '../../_services/index';

import {Tenant} from '../../_models/index';

import {Role} from '../../helpers/role';
import {DOCUMENT} from "@angular/common";
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {OidcService} from "../../_services/oidc.service";
import {LoginHelper} from "../../helpers";
import {LogoutHubService} from "../../_services/signalr/logoutHub.service";

@Component({
    standalone: false,
  selector: "login",
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  loading = false;
  customDomain = false;
  isRoot = false;
  returnUrl: string;
  tenants: Tenant[];
  selectedTenant: string;
  tenantName: string;
  RiskSpongeMaster: string = 'riskspongemaster';
  loginText: string = (window as any).loginText;
  mfaActive: boolean = false;
  settings: any;
  masterSettings: any;
  public tenantSubject = new Subject<string>();
  tenant = null;
  loginLogo: string = null;
  loginImage: string = null;
  hidePassword = true;

  formGroup: FormGroup;

  constructor(
    @Inject(DOCUMENT) public document,
    public route: ActivatedRoute,
    public router: Router,
    public authenticationService: AuthenticationService,
    public tenantService: TenantService,
    public alertService: AlertService,
    public clientProfileService: ClientProfileService,
    public formBuilder: FormBuilder,
    public oidcService: OidcService,
    public logoutHubService: LogoutHubService,
    //TODO : Migration
    //public msalService: MsalService,
  ) {

    this.clientProfileService.getMasterPublicSettings().subscribe((data: any) => {
      this.masterSettings = data;
      if (data && data.loginLogo) {
        this.loginLogo = window.location.origin + '/api/attachments/loginLogo?tenantName=' + LoginHelper.getTenantNameFromUrl();
      }
      if (data && data.loginImage) {
        this.loginImage = window.location.origin + '/api/attachments/loginImage?tenantName=' + LoginHelper.getTenantNameFromUrl();
      }
    });
    this.formGroup = formBuilder.group({
      tenantName: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      mfaCode: ['', Validators.required],
    });
    this.updateValidators();
  }

  updateValidators() {
    if (this.mfaActive)
    {
      this.formGroup.get('tenantName').setValidators([]);
      this.formGroup.get('username').setValidators([]);
      this.formGroup.get('password').setValidators([]);
      this.formGroup.get('mfaCode').setValidators([Validators.required]);
    }
    else
    {
      this.formGroup.get('tenantName').setValidators([Validators.required]);
      this.formGroup.get('username').setValidators([Validators.required]);
      this.formGroup.get('password').setValidators([Validators.required]);
      this.formGroup.get('mfaCode').setValidators([]);
    }
    if (this.customDomain) {
      this.formGroup.get('tenantName').setValidators([Validators.required]);
    }
    else
    {
      this.formGroup.get('tenantName').setValidators([]);
    }
    this.formGroup.get('tenantName').updateValueAndValidity();
    this.formGroup.get('username').updateValueAndValidity();
    this.formGroup.get('password').updateValueAndValidity();
    this.formGroup.get('mfaCode').updateValueAndValidity();
  }

  ngOnInit() {
    this.alertService.suppressRootAlert.next(true);
    // reset login status
    this.authenticationService.cleanupTokens();

    this.tenantName = this.getTenantName();
    //this.selectedTenant = "riskspongetest3";

    if (this.tenantName != null) {
      this.tenantService.tenantExists(this.tenantName).subscribe(data => {
          if (!data) {
            window.location.href = this.getTenantlessUrl();
          }
        },
        error => {
          const errorMessage = 'An error occurred while loading tenants.';
          this.alertService.error(errorMessage);
        });

      this.clientProfileService.getPublicSettings(this.tenantName).subscribe(t => this.settings = t, error => this.settings = {});
      this.tenantService.getCurrent().subscribe(t => this.tenant = t);
    }
    else {
      this.settings = {};
    }


    const hostParts = location.hostname.toLowerCase().split('.');
    this.isRoot = (<any>window).tenantHostnameTemplate.indexOf('{0}') < 0 || hostParts.length <= 2 || hostParts[0] == 'app' || (<any>window).tenantHostnameTemplate.replace('{0}', 'app') == location.hostname;
    let clientProfileService = this.clientProfileService;

    this.tenantSubject.pipe(debounceTime(500)).subscribe(v => {
      clientProfileService.getPublicSettings(v).subscribe(t => this.settings = t)
    });
  }

  onLogin() {
    this.formGroup.controls.tenantName.markAsTouched();
    this.formGroup.controls.username.markAsTouched();
    this.formGroup.controls.password.markAsTouched();
    this.formGroup.controls.mfaCode.markAsTouched();
    if (!this.formGroup.valid) return;
    this.loading = true;
    this.alertService.clear();

    //console.log(this.selectedTenant);

    const tenant = this.tenantName == null
      ? this.formGroup.value.tenantName
      : this.tenantName;

    this.authenticationService.logout();
    this.authenticationService.login(this.formGroup.value.username, this.formGroup.value.password, this.formGroup.value.mfaCode, tenant)
      .subscribe(
        data => {
          if (data.mfa) {
            this.mfaActive = true;
            this.updateValidators();
            this.loading = false;
            return;
          }
          this.loggedIn();
        },
        error => {

          this.loading = false;
        });
  }

  private loggedIn() {
    this.authenticationService.logoutAllSessions();
    this.logoutHubService.startConnection();
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    let returnUrl = this.route.queryParams['value']['returnUrl'];
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else if (currentUser.role == Role.KingAdmin) {
      this.router.navigate(['/tenants']);
    } else if (currentUser.role == Role.Training) {
      this.router.navigate(['/training']);
    } else if (currentUser.role == Role.Survey) {
      this.router.navigate(['/assessments']);
    } else if (currentUser.role == Role.Vendor) {
      this.router.navigate(['/projects']);
    } else if (currentUser.role == Role.TrustCenterViewer) {
      this.router.navigate(['/trustBuilderView']);
    } else if (currentUser.role == Role.Engineer) {
      this.router.navigate(['/workstreams']);
    } else {
      this.router.navigate(['']);
    }
  }

  onOidcLogin() {
    if (!this.settings) {
      this.alertService.error("Please, enter tenant name");
      return;
    }
    var tenant = this.tenantName == null
      ? this.selectedTenant
      : this.tenantName;

    const userManager = this.oidcService.getUserManager(this.settings, tenant);

    userManager.signinPopup().then((user) =>{
      this.loading = true;
      this.authenticationService.loginOidc(user.id_token, tenant).subscribe(data => {
        this.loggedIn();
      }, error => {

        this.loading = false;
      });
    }).catch((error) => {
      this.alertService.error(error);
    })
  }

  /*onAzureLogin() {
    var tenant = this.tenantName == null
      ? this.selectedTenant
      : this.tenantName;

    if (!tenant) {
      this.alertService.error("Please, enter tenant name");
      return;
    }

    this.clientProfileService.getSettings(tenant).subscribe(t => {
      let config: MsalConfig = {
        clientID: t.azureApplicationId,//'85bac8cf-9370-4801-a08e-85aa3f28229a',
        authority: 'https://login.microsoftonline.com/' + t.azureDirectoryId + '/', //d53e92d9-db25-4a30-9c7f-7db8c2720c2a
        validateAuthority: true,
        redirectUri: location.protocol + "//" + location.hostname,
        //postLogoutRedirectUri: location.protocol + "//" + location.hostname + ":" + location.port,
        //navigateToLoginRequestUri: true,
        cacheLocation: 'localStorage',
        //storeAuthStateInCookie: true,
        popUp: true,
        consentScopes: [
          "user.read",
          "openid",
          "profile",
          "api",
          "api://" + t.azureDirectoryId + "/access_as_user"//d53e92d9-db25-4a30-9c7f-7db8c2720c2a
        ],
        unprotectedResources: ['https://www.microsoft.com/en-us/'],
      }


      this.msalService.initConfig(config);
      this.msalService.loginPopup().then((token) => {
        //this.msalService.
        this.authenticationService.loginAzure(token, tenant)
          .subscribe(
            data => {
              if (data.mfa) {
                this.mfaActive = true;
                this.loading = false;
                return;
              }
              let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
              if (currentUser.role != Role.KingAdmin) {
                this.router.navigate(['']);
              } else {
                this.router.navigate(['/tenants']);
              }

            },
            error => {

              this.loading = false;
            });
      });
    });
  }*/

  public getRegisterTenantUrl() {
    return 'https://rizklycommunity.com'
  }

  public getTenantName() {
    return LoginHelper.getTenantNameFromUrl()
  }
  public getTenantlessUrl() {
    let hostname = this.document.location.hostname;
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(hostname)) {
      return window.location.href;
    }

    if (this.getTenantName()) {
      return window.location.protocol + "//" + window.location.hostname.split('.').slice(1).join('.') + ":" + window.location.port;
    }

    return window.location.protocol + "//" + window.location.hostname.replace(this.getTenantName(), 'app') + ":" + window.location.port;
  }

  public createTenant() {
    console.log(`${this.getRegisterTenantUrl()}/createAccount`);
    window.location.href = `${this.getRegisterTenantUrl()}/createAccount`;
  }

  public tenantCheck(event) {
    this.selectedTenant = event.target.value
    this.tenantSubject.next(this.selectedTenant);
  }

  protected readonly location = location;
}
